/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as PairRouteImport } from './routes/pair'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppActivityRouteImport } from './routes/_app/activity'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppModelsRouteImport } from './routes/_app/models'
import { Route as AppDevicesIndexRouteImport } from './routes/_app/devices.index'
import { Route as AppDevicesDeviceIdRouteImport } from './routes/_app/devices.$deviceId'
import { Route as AppInboxIndexRouteImport } from './routes/_app/inbox.index'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects.index'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app/projects.$projectId'
import { Route as AppWorkspacesWorkspaceIdRouteImport } from './routes/_app/workspaces.$workspaceId'
import { Route as AppInboxDeviceIdApprovalIdRouteImport } from './routes/_app/inbox.$deviceId.$approvalId'
import { Route as AppProjectsProjectIdIndexRouteImport } from './routes/_app/projects.$projectId.index'
import { Route as AppProjectsProjectIdGraphRouteImport } from './routes/_app/projects.$projectId.graph'
import { Route as AppProjectsProjectIdModulesRouteImport } from './routes/_app/projects.$projectId.modules'
import { Route as AppProjectsProjectIdPolicyRouteImport } from './routes/_app/projects.$projectId.policy'
import { Route as AppProjectsProjectIdDecisionsIndexRouteImport } from './routes/_app/projects.$projectId.decisions.index'
import { Route as AppProjectsProjectIdDevicesDeviceIdRouteImport } from './routes/_app/projects.$projectId.devices.$deviceId'
import { Route as AppProjectsProjectIdDecisionsDeviceIdEvaluationIdRouteImport } from './routes/_app/projects.$projectId.decisions.$deviceId.$evaluationId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PairRoute = PairRouteImport.update({
  id: '/pair',
  path: '/pair',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppActivityRoute = AppActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppModelsRoute = AppModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesIndexRoute = AppDevicesIndexRouteImport.update({
  id: '/devices/',
  path: '/devices/',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesDeviceIdRoute = AppDevicesDeviceIdRouteImport.update({
  id: '/devices/$deviceId',
  path: '/devices/$deviceId',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxIndexRoute = AppInboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInboxRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkspacesWorkspaceIdRoute =
  AppWorkspacesWorkspaceIdRouteImport.update({
    id: '/workspaces/$workspaceId',
    path: '/workspaces/$workspaceId',
    getParentRoute: () => AppRoute,
  } as any)
const AppInboxDeviceIdApprovalIdRoute =
  AppInboxDeviceIdApprovalIdRouteImport.update({
    id: '/$deviceId/$approvalId',
    path: '/$deviceId/$approvalId',
    getParentRoute: () => AppInboxRoute,
  } as any)
const AppProjectsProjectIdIndexRoute =
  AppProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdGraphRoute =
  AppProjectsProjectIdGraphRouteImport.update({
    id: '/graph',
    path: '/graph',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdModulesRoute =
  AppProjectsProjectIdModulesRouteImport.update({
    id: '/modules',
    path: '/modules',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdPolicyRoute =
  AppProjectsProjectIdPolicyRouteImport.update({
    id: '/policy',
    path: '/policy',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdDecisionsIndexRoute =
  AppProjectsProjectIdDecisionsIndexRouteImport.update({
    id: '/decisions/',
    path: '/decisions/',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdDevicesDeviceIdRoute =
  AppProjectsProjectIdDevicesDeviceIdRouteImport.update({
    id: '/devices/$deviceId',
    path: '/devices/$deviceId',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdDecisionsDeviceIdEvaluationIdRoute =
  AppProjectsProjectIdDecisionsDeviceIdEvaluationIdRouteImport.update({
    id: '/decisions/$deviceId/$evaluationId',
    path: '/decisions/$deviceId/$evaluationId',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/pair': typeof PairRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/activity': typeof AppActivityRoute
  '/inbox': typeof AppInboxRouteWithChildren
  '/models': typeof AppModelsRoute
  '/devices/$deviceId': typeof AppDevicesDeviceIdRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/workspaces/$workspaceId': typeof AppWorkspacesWorkspaceIdRoute
  '/devices/': typeof AppDevicesIndexRoute
  '/inbox/': typeof AppInboxIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/inbox/$deviceId/$approvalId': typeof AppInboxDeviceIdApprovalIdRoute
  '/projects/$projectId/graph': typeof AppProjectsProjectIdGraphRoute
  '/projects/$projectId/modules': typeof AppProjectsProjectIdModulesRoute
  '/projects/$projectId/policy': typeof AppProjectsProjectIdPolicyRoute
  '/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
  '/projects/$projectId/devices/$deviceId': typeof AppProjectsProjectIdDevicesDeviceIdRoute
  '/projects/$projectId/decisions/': typeof AppProjectsProjectIdDecisionsIndexRoute
  '/projects/$projectId/decisions/$deviceId/$evaluationId': typeof AppProjectsProjectIdDecisionsDeviceIdEvaluationIdRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/pair': typeof PairRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/activity': typeof AppActivityRoute
  '/models': typeof AppModelsRoute
  '/': typeof AppIndexRoute
  '/devices/$deviceId': typeof AppDevicesDeviceIdRoute
  '/workspaces/$workspaceId': typeof AppWorkspacesWorkspaceIdRoute
  '/devices': typeof AppDevicesIndexRoute
  '/inbox': typeof AppInboxIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/inbox/$deviceId/$approvalId': typeof AppInboxDeviceIdApprovalIdRoute
  '/projects/$projectId/graph': typeof AppProjectsProjectIdGraphRoute
  '/projects/$projectId/modules': typeof AppProjectsProjectIdModulesRoute
  '/projects/$projectId/policy': typeof AppProjectsProjectIdPolicyRoute
  '/projects/$projectId': typeof AppProjectsProjectIdIndexRoute
  '/projects/$projectId/devices/$deviceId': typeof AppProjectsProjectIdDevicesDeviceIdRoute
  '/projects/$projectId/decisions': typeof AppProjectsProjectIdDecisionsIndexRoute
  '/projects/$projectId/decisions/$deviceId/$evaluationId': typeof AppProjectsProjectIdDecisionsDeviceIdEvaluationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/pair': typeof PairRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/_app/activity': typeof AppActivityRoute
  '/_app/inbox': typeof AppInboxRouteWithChildren
  '/_app/models': typeof AppModelsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/devices/$deviceId': typeof AppDevicesDeviceIdRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/_app/workspaces/$workspaceId': typeof AppWorkspacesWorkspaceIdRoute
  '/_app/devices/': typeof AppDevicesIndexRoute
  '/_app/inbox/': typeof AppInboxIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/inbox/$deviceId/$approvalId': typeof AppInboxDeviceIdApprovalIdRoute
  '/_app/projects/$projectId/graph': typeof AppProjectsProjectIdGraphRoute
  '/_app/projects/$projectId/modules': typeof AppProjectsProjectIdModulesRoute
  '/_app/projects/$projectId/policy': typeof AppProjectsProjectIdPolicyRoute
  '/_app/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
  '/_app/projects/$projectId/devices/$deviceId': typeof AppProjectsProjectIdDevicesDeviceIdRoute
  '/_app/projects/$projectId/decisions/': typeof AppProjectsProjectIdDecisionsIndexRoute
  '/_app/projects/$projectId/decisions/$deviceId/$evaluationId': typeof AppProjectsProjectIdDecisionsDeviceIdEvaluationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/pair'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/activity'
    | '/inbox'
    | '/models'
    | '/devices/$deviceId'
    | '/projects/$projectId'
    | '/workspaces/$workspaceId'
    | '/devices/'
    | '/inbox/'
    | '/projects/'
    | '/inbox/$deviceId/$approvalId'
    | '/projects/$projectId/graph'
    | '/projects/$projectId/modules'
    | '/projects/$projectId/policy'
    | '/projects/$projectId/'
    | '/projects/$projectId/devices/$deviceId'
    | '/projects/$projectId/decisions/'
    | '/projects/$projectId/decisions/$deviceId/$evaluationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/pair'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/activity'
    | '/models'
    | '/'
    | '/devices/$deviceId'
    | '/workspaces/$workspaceId'
    | '/devices'
    | '/inbox'
    | '/projects'
    | '/inbox/$deviceId/$approvalId'
    | '/projects/$projectId/graph'
    | '/projects/$projectId/modules'
    | '/projects/$projectId/policy'
    | '/projects/$projectId'
    | '/projects/$projectId/devices/$deviceId'
    | '/projects/$projectId/decisions'
    | '/projects/$projectId/decisions/$deviceId/$evaluationId'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/pair'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/_app/activity'
    | '/_app/inbox'
    | '/_app/models'
    | '/_app/'
    | '/_app/devices/$deviceId'
    | '/_app/projects/$projectId'
    | '/_app/workspaces/$workspaceId'
    | '/_app/devices/'
    | '/_app/inbox/'
    | '/_app/projects/'
    | '/_app/inbox/$deviceId/$approvalId'
    | '/_app/projects/$projectId/graph'
    | '/_app/projects/$projectId/modules'
    | '/_app/projects/$projectId/policy'
    | '/_app/projects/$projectId/'
    | '/_app/projects/$projectId/devices/$deviceId'
    | '/_app/projects/$projectId/decisions/'
    | '/_app/projects/$projectId/decisions/$deviceId/$evaluationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  PairRoute: typeof PairRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pair': {
      id: '/pair'
      path: '/pair'
      fullPath: '/pair'
      preLoaderRoute: typeof PairRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/models': {
      id: '/_app/models'
      path: '/models'
      fullPath: '/models'
      preLoaderRoute: typeof AppModelsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices/': {
      id: '/_app/devices/'
      path: '/devices'
      fullPath: '/devices/'
      preLoaderRoute: typeof AppDevicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices/$deviceId': {
      id: '/_app/devices/$deviceId'
      path: '/devices/$deviceId'
      fullPath: '/devices/$deviceId'
      preLoaderRoute: typeof AppDevicesDeviceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox/': {
      id: '/_app/inbox/'
      path: '/'
      fullPath: '/inbox/'
      preLoaderRoute: typeof AppInboxIndexRouteImport
      parentRoute: typeof AppInboxRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workspaces/$workspaceId': {
      id: '/_app/workspaces/$workspaceId'
      path: '/workspaces/$workspaceId'
      fullPath: '/workspaces/$workspaceId'
      preLoaderRoute: typeof AppWorkspacesWorkspaceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox/$deviceId/$approvalId': {
      id: '/_app/inbox/$deviceId/$approvalId'
      path: '/$deviceId/$approvalId'
      fullPath: '/inbox/$deviceId/$approvalId'
      preLoaderRoute: typeof AppInboxDeviceIdApprovalIdRouteImport
      parentRoute: typeof AppInboxRoute
    }
    '/_app/projects/$projectId/': {
      id: '/_app/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AppProjectsProjectIdIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/graph': {
      id: '/_app/projects/$projectId/graph'
      path: '/graph'
      fullPath: '/projects/$projectId/graph'
      preLoaderRoute: typeof AppProjectsProjectIdGraphRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/modules': {
      id: '/_app/projects/$projectId/modules'
      path: '/modules'
      fullPath: '/projects/$projectId/modules'
      preLoaderRoute: typeof AppProjectsProjectIdModulesRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/policy': {
      id: '/_app/projects/$projectId/policy'
      path: '/policy'
      fullPath: '/projects/$projectId/policy'
      preLoaderRoute: typeof AppProjectsProjectIdPolicyRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/decisions/': {
      id: '/_app/projects/$projectId/decisions/'
      path: '/decisions'
      fullPath: '/projects/$projectId/decisions/'
      preLoaderRoute: typeof AppProjectsProjectIdDecisionsIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/devices/$deviceId': {
      id: '/_app/projects/$projectId/devices/$deviceId'
      path: '/devices/$deviceId'
      fullPath: '/projects/$projectId/devices/$deviceId'
      preLoaderRoute: typeof AppProjectsProjectIdDevicesDeviceIdRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/decisions/$deviceId/$evaluationId': {
      id: '/_app/projects/$projectId/decisions/$deviceId/$evaluationId'
      path: '/decisions/$deviceId/$evaluationId'
      fullPath: '/projects/$projectId/decisions/$deviceId/$evaluationId'
      preLoaderRoute: typeof AppProjectsProjectIdDecisionsDeviceIdEvaluationIdRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
  }
}

interface AppInboxRouteChildren {
  AppInboxIndexRoute: typeof AppInboxIndexRoute
  AppInboxDeviceIdApprovalIdRoute: typeof AppInboxDeviceIdApprovalIdRoute
}

const AppInboxRouteChildren: AppInboxRouteChildren = {
  AppInboxIndexRoute: AppInboxIndexRoute,
  AppInboxDeviceIdApprovalIdRoute: AppInboxDeviceIdApprovalIdRoute,
}

const AppInboxRouteWithChildren = AppInboxRoute._addFileChildren(
  AppInboxRouteChildren,
)

interface AppProjectsProjectIdRouteChildren {
  AppProjectsProjectIdGraphRoute: typeof AppProjectsProjectIdGraphRoute
  AppProjectsProjectIdModulesRoute: typeof AppProjectsProjectIdModulesRoute
  AppProjectsProjectIdPolicyRoute: typeof AppProjectsProjectIdPolicyRoute
  AppProjectsProjectIdIndexRoute: typeof AppProjectsProjectIdIndexRoute
  AppProjectsProjectIdDevicesDeviceIdRoute: typeof AppProjectsProjectIdDevicesDeviceIdRoute
  AppProjectsProjectIdDecisionsIndexRoute: typeof AppProjectsProjectIdDecisionsIndexRoute
  AppProjectsProjectIdDecisionsDeviceIdEvaluationIdRoute: typeof AppProjectsProjectIdDecisionsDeviceIdEvaluationIdRoute
}

const AppProjectsProjectIdRouteChildren: AppProjectsProjectIdRouteChildren = {
  AppProjectsProjectIdGraphRoute: AppProjectsProjectIdGraphRoute,
  AppProjectsProjectIdModulesRoute: AppProjectsProjectIdModulesRoute,
  AppProjectsProjectIdPolicyRoute: AppProjectsProjectIdPolicyRoute,
  AppProjectsProjectIdIndexRoute: AppProjectsProjectIdIndexRoute,
  AppProjectsProjectIdDevicesDeviceIdRoute:
    AppProjectsProjectIdDevicesDeviceIdRoute,
  AppProjectsProjectIdDecisionsIndexRoute:
    AppProjectsProjectIdDecisionsIndexRoute,
  AppProjectsProjectIdDecisionsDeviceIdEvaluationIdRoute:
    AppProjectsProjectIdDecisionsDeviceIdEvaluationIdRoute,
}

const AppProjectsProjectIdRouteWithChildren =
  AppProjectsProjectIdRoute._addFileChildren(AppProjectsProjectIdRouteChildren)

interface AppRouteChildren {
  AppActivityRoute: typeof AppActivityRoute
  AppInboxRoute: typeof AppInboxRouteWithChildren
  AppModelsRoute: typeof AppModelsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppDevicesDeviceIdRoute: typeof AppDevicesDeviceIdRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRouteWithChildren
  AppWorkspacesWorkspaceIdRoute: typeof AppWorkspacesWorkspaceIdRoute
  AppDevicesIndexRoute: typeof AppDevicesIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActivityRoute: AppActivityRoute,
  AppInboxRoute: AppInboxRouteWithChildren,
  AppModelsRoute: AppModelsRoute,
  AppIndexRoute: AppIndexRoute,
  AppDevicesDeviceIdRoute: AppDevicesDeviceIdRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRouteWithChildren,
  AppWorkspacesWorkspaceIdRoute: AppWorkspacesWorkspaceIdRoute,
  AppDevicesIndexRoute: AppDevicesIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  PairRoute: PairRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
